<template>
  <div>
    <div class="split-card">
      <div @click="completeFirst" :class="{finished: completedFirsts.includes(index)}" v-if="firsts[index]">
        <b-icon icon="check2" v-if="completedFirsts.includes(index)"></b-icon>
        <h2 class="card-title">First</h2>
        <b-img v-if="!hideImg" fluid :src="firsts[index].image" height="100" width="100" center rounded></b-img>
        <h3 v-if="!hideTitle">{{ firsts[index].title }}</h3>
      </div>
      <div @click="completeThen" :class="{finished: completedThens.includes(index)}">
        <div v-if="thens[index]">
          <b-icon icon="check2" v-if="completedThens.includes(index)"></b-icon>
          <h2 class="card-title">Then</h2>
          <b-img v-if="!hideImg" fluid :src="thens[index].image" height="100" width="100" center rounded></b-img>
          <h3 v-if="!hideTitle">{{ thens[index].title }}</h3>
        </div>
        <div v-else>
          <p>Add an even number of cards. Cards in odd positions become "First" and evens become "Then"</p>
        </div>
      </div>
    </div>
    <div class="row mt-3 non-share">
      <div class="col">
        <b-button @click="restart" v-if="completedFirsts.length" size="sm" variant="secondary">
          <b-icon icon="arrow-counterclockwise"></b-icon> Restart</b-button>
      </div>
      <div class="col text-right">
        <b-button @click="handlePrev" v-if="index > 0" size="sm" variant="secondary">
          <b-icon icon="arrow-left"></b-icon>Back</b-button>
        <b-button @click="handleNext"
          v-if="hasRemaining"
          size="sm" variant="primary"
          :disabled="!completedFirsts.includes(index) || !completedThens.includes(index)">
          Next <b-icon icon="arrow-right"></b-icon></b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
  props: {
    previewMode: {
      type: Boolean,
      required: true,
    },
  },

  mounted() {
    this.setPairs();
  },

  watch: {
    completedFirsts() {
      this.updateVisualScheduleContent(true);
    },

    completedThens() {
      this.updateVisualScheduleContent(true);
    },

    index() {
      this.updateVisualScheduleContent(true);
    },

    scheduleCards() {
      this.setPairs();
    },
  },

  data() {
    return {
      firsts: [],
      thens: [],
      index: 0,
      completedFirsts: [],
      completedThens: [],
    };
  },

  computed: {
    ...mapState(['visualSchedule']),
    ...mapGetters(['scheduleCards', 'hideTitle', 'hideImg']),

    displayId() {
      return this.visualSchedule.visual_schedule_display_id;
    },

    hasRemaining() {
      return this.index + 1 < this.firsts.length;
    },
  },

  methods: {
    ...mapMutations(['updateVisualScheduleContent']),

    completeFirst() {
      if (!this.firsts[this.index]) return;

      if (!this.completedFirsts.includes(this.index)) {
        this.completedFirsts.push(this.index);
      } else {
        const index = this.completedFirsts.findIndex((f) => f === this.index);
        if (index >= 0) this.completedFirsts.splice(index, 1);
      }
    },

    completeThen() {
      if (!this.thens[this.index]) return;

      if (!this.completedThens.includes(this.index)) {
        this.completedThens.push(this.index);
      } else {
        const index = this.completedThens.findIndex((f) => f === this.index);
        if (index >= 0) this.completedThens.splice(index, 1);
      }
    },

    handleNext() {
      if (this.hasRemaining) {
        this.index += 1;
      }
    },

    handlePrev() {
      this.index -= 1;
    },

    setPairs() {
      const cards = [...this.scheduleCards];
      this.firsts = cards.filter((card, i) => ((i + 1) % 2) !== 0);
      this.thens = cards.filter((card, i) => ((i + 1) % 2) === 0);
    },

    addToCompleted(card) {
      if (this.cardFinished(card)) {
        this.removeFromCompleted(card);
        return;
      }
      this.completedCards.push(card);
    },

    onStart() {
      this.trashDragging = true;
    },

    onEnd() {
      this.trashDragging = false;
    },

    removeFromCompleted(card) {
      const index = this.trashed.findIndex((c) => c.card_id === card.card_id);
      if (index !== -1) {
        this.trashed.splice(index, 1);
        this.active.push(card);
        this.active.sort((a, b) => a.position - b.position);
      }
    },

    cardFinished(card) {
      return this.completedCards.find((c) => c.card_id === card.card_id && card.position === c.position);
    },

    restart() {
      this.index = 0;
      this.completedFirsts = [];
      this.completedThens = [];
    },
  },
};
</script>
